import Icon from '../primitives/Icon.jsx';

/** What to show when a list has nothing yet: what goes here and the action that adds it. */
const EmptyState = ({ icon, title, description, action }) => {
  return (
    <div className="comp-empty-state">
      {icon && (
        <span className="comp-empty-state__icon">
          <Icon icon={icon} size="lg" />
        </span>
      )}
      <h3 className="comp-empty-state__title">{title}</h3>
      {description && <p className="comp-empty-state__description">{description}</p>}
      {action && <div className="comp-empty-state__action">{action}</div>}
    </div>
  );
};

export default EmptyState;
